var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 6,
    viewBox: "0 0 24 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8421 6C19.098 6 17.6842 4.65685 17.6842 3C17.6842 1.34315 19.098 6.61928e-07 20.8421 7.34351e-07C22.5862 8.06775e-07 24 1.34315 24 3C24 4.65685 22.5862 6 20.8421 6Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C10.2559 6 8.8421 4.65685 8.8421 3C8.8421 1.34315 10.2559 2.94753e-07 12 3.67176e-07C13.7441 4.39599e-07 15.1579 1.34315 15.1579 3C15.1579 4.65685 13.7441 6 12 6Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15789 6C1.41384 6 -7.62352e-08 4.65685 0 3C7.62352e-08 1.34315 1.41384 -7.24234e-08 3.15789 0C4.90195 7.24234e-08 6.31579 1.34315 6.31579 3C6.31579 4.65685 4.90195 6 3.15789 6Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.af94b61230b01090445593f8c204ba87.svg";
export { ForwardRef as ReactComponent };